import React from 'react';
import Link from '../base/Link';
import API from "../base/API";
import Auth from "../auth/Auth";
import Storage from "../base/Storage";
import SorTable from '../base/SorTable';
import DeleteButton from "../base/DeleteButton";
import { translate } from "../base/Translation";

export default class WeaveGroupList extends Auth {

	constructor(props) {
		super(props);

		this.api = new API({
			get_weave_groups: "/weave_group/fetch/all?limit_from=:from&limit_max=:to&brand=:brand",
			delete_weave_group: "/weave_group/delete/:weave_group"
		});

		this.state = {
			weave_groups: [],
			tableData: [],
			tableColumns: [
				{ name: "name", display: translate("Názov"), sort: true, width: 26 },
				{ name: "weaves", display: translate("Vlny"), sort: true, width: 70 },
				{ name: "options", display: " ", width: 4 }
			]
		};
	}

	convertDataForTable(data) {
		return data.map(function (weave_group) {
			weave_group.name = <Link to={"/weave_groups/edit/" + weave_group.id} textIfNoAccess={true} permission="WeaveGroupEdit">{weave_group.name}</Link>

			weave_group.weaves = weave_group.weaves.map((weave, index) => {
				return weave.name
			}).join(", ");

			weave_group.options = (
				<div style={{ textAlign: "right" }}>
					<DeleteButton onClick={this.deleteWeaveGroup.bind({ weave_group: weave_group.id, currentComponent: this })} permission="WeaveGroupNew" />
				</div>
			);
			return weave_group;
		}.bind(this));
	}

	fetchData() {
		let brandFilter = Storage.get("brand_filter");
		this.api.request({
			cache: true,
			route: "get_weave_groups",
			params: { from: 0, to: 99999, brand: brandFilter ? brandFilter.id : "all" },
			success: (response) => {
				let tableData = this.convertDataForTable(response);
				this.setState({ weave_groups: response, tableData });
			}
		});
	}

	componentDidMount() {
		this.fetchData();
	}

	deleteWeaveGroup(evt) {
		this.currentComponent.api.request({
			route: "delete_weave_group",
			params: { weave_group: this.weave_group },
			success: (response) => {
				this.currentComponent.fetchData();
			}
		});
	}

	render() {
		return (
			<SorTable columns={this.state.tableColumns} data={this.state.tableData} headers={true} searchBy="name" title={translate("Skupiny vĺn")} right={() => {
				if (Storage.get("allowed_components").indexOf("WeaveGroupNew") === -1) {
					return "";
				}
				return (
					<Link to="/weave_groups/add/new" className="btn btn-success btn-sm pull-right"><i className="fa fa-plus" /> {translate("Pridať")}</Link>
				)
			}} />
		);
	}
}


// WEBPACK FOOTER //
// ./src/modules/weave_group/WeaveGroupList.js